import Navbar from '../components/navbar/navbar';
import ContactsBanner from "../components/contacts/contacts";

const Contacts: React.FC = () => {
  return (
    <>
        <Navbar/>
        <ContactsBanner/>
    </>
  );
};

export default Contacts;